export const BrowserWindowSymbol = Symbol('BrowserWindow')
export const ViewerModelSym = Symbol('ViewerModel')
export const LanguageSymbol = Symbol('Language')
export const ViewModeSym = Symbol('ViewMode')
export const RendererPropsExtenderSym = Symbol('RendererPropsExtenderSym')
export const ComponentLibrariesSymbol = Symbol('ComponentLibraries')
export const LoggerSymbol = Symbol('LOG')
export const MockModulesForTestsSymbol = Symbol('MockModulesForTestsSymbol')
export const WixCodeSdkParamsProviderSym = Symbol('WixCodeSdkParamsProviderSym')
export const PlatformEvnDataProviderSymbol = Symbol('PlatformEvnDataProviderSymbol')
export const PlatformViewportAPISym = Symbol('PlatformViewportAPISym')
export const WixCodeSdkHandlersProviderSym = Symbol('WixCodeSdkHandlersProviderSym')
export const PlatformSymbol = Symbol('PlatformSymbol')
export const PlatformStorageSymbol = Symbol('PlatformStorageSymbol')
export const PlatformWorkerPromiseSym = Symbol('PlatformWorkerPromiseSym')
export const AppDidMountPromiseSymbol = Symbol('AppDidMountPromiseSymbol')
export const RendererSymbol = Symbol('RendererSymbol')
export const DomReadySymbol = Symbol('DomReady')
export const PlatformPropsSyncManagerSymbol = Symbol('PlatformPropsSyncManager')
